import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Film, Lock, Clock, Video, Sparkles } from 'lucide-react';

export default function VideoGalleryPage() {
  const { user } = useAuth();
  const canAccessGallery = user?.subscription_tier === 'platinum' || user?.subscription_tier === 'ultimate';

  if (!canAccessGallery) {
    return (
      <div className="p-6" data-testid="video-gallery-upgrade">
        <div className="max-w-2xl mx-auto text-center py-16">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-violet-500/20 to-fuchsia-500/20 flex items-center justify-center">
            <Film className="w-10 h-10 text-coral-500" />
          </div>
          <h1 className="text-3xl font-bold text-ink-950 mb-4">Video Gallery</h1>
          <p className="text-ink-500 mb-8">
            AI video generation is available for Platinum and Ultimate plans. 
            Upgrade to create stunning marketing videos and access your video library!
          </p>
          <Button 
            onClick={() => window.location.href = '/dashboard/subscription'}
            className="bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:from-violet-500 hover:to-fuchsia-500"
          >
            Upgrade to Platinum
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6" data-testid="video-gallery-page">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-violet-500/20 to-fuchsia-500/20 flex items-center justify-center border border-coral-500/30">
          <Film className="w-10 h-10 text-coral-500" />
        </div>
        <h1 className="text-3xl font-bold text-ink-950 mb-3">Video Gallery</h1>
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full">
          <Clock className="w-4 h-4 text-amber-400" />
          <span className="text-amber-400 font-medium">Coming Soon</span>
        </div>
      </div>

      {/* Coming Soon Card */}
      <div className="max-w-2xl mx-auto bg-ink-50 rounded-2xl border border-ink-200/50 p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-ink-200/50 flex items-center justify-center">
          <Lock className="w-8 h-8 text-ink-500" />
        </div>
        
        <h2 className="text-xl font-semibold text-ink-950 mb-3">
          Your Videos Will Appear Here
        </h2>
        <p className="text-ink-500 mb-8">
          Once AI video generation launches, all your created marketing videos 
          will be stored here for easy access, download, and sharing.
        </p>

        {/* Features Preview */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="bg-white/60 rounded-xl p-4 border border-ink-200/50">
            <Video className="w-6 h-6 text-coral-500 mx-auto mb-2" />
            <h3 className="text-ink-950 font-medium mb-1">Video Library</h3>
            <p className="text-ink-500 text-sm">All your generated videos in one place</p>
          </div>
          <div className="bg-white/60 rounded-xl p-4 border border-ink-200/50">
            <Sparkles className="w-6 h-6 text-fuchsia-400 mx-auto mb-2" />
            <h3 className="text-ink-950 font-medium mb-1">Easy Sharing</h3>
            <p className="text-ink-500 text-sm">Download & share to social media</p>
          </div>
        </div>

        <p className="text-ink-500 text-sm">
          You'll be notified when video generation launches!
        </p>
      </div>
    </div>
  );
}
